export const OAUTH_CONSENT_DECISION = {
  approve: 'approve',
  deny: 'deny',
} as const;

export type OAuthConsentDecision =
  (typeof OAUTH_CONSENT_DECISION)[keyof typeof OAUTH_CONSENT_DECISION];
